/**
 * @file AssessmentReviewPanel.tsx
 * @brief Doctor review workspace: Word-style MLR document (outline + paper).
 *
 * @details
 * Clinic finish is mobile. This panel is the post-generation editor — one
 * document, not a stack of forms (08-09-2026). Generate / records import /
 * advanced tools live in the Tools sheet on MedicalAssessmentDetailPage.
 *
 * @author DES
 * @date 02-09-2026
 * @updated 08-09-2026 — replace stacked panels with MlrReportDocument
 */

import type { AssessmentStatement, CaseHub, MedicalAssessment } from "../schemas";
import { useMlrSupplements } from "../api";
import { MlrReportDocument } from "./MlrReportDocument";

type Props = {
  assessmentId: string;
  assessment: MedicalAssessment;
  statements: AssessmentStatement[];
  caseHub?: CaseHub;
  onRefetch: () => void;
};

export function AssessmentReviewPanel({
  assessmentId,
  assessment,
  statements,
  caseHub,
  onRefetch,
}: Props) {
  const mlrSupplements = useMlrSupplements(assessmentId);
  const isSigned = mlrSupplements.data?.statementOfTruthConfirmed === true;

  return (
    <MlrReportDocument
      assessmentId={assessmentId}
      assessment={assessment}
      statements={statements}
      caseHub={caseHub}
      onSaved={onRefetch}
      showSignedEditHint={isSigned}
    />
  );
}
